import React from 'react'
import './Search.scss'

const Search = ({ placeholder, value, onChange }) => {
  return (
    <div className='search-container'>
      <img src={require('../../../../assets/icons/search.svg')} alt='search-icon' />
      <input
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  )
}

export default Search
